import { SubPackageSlugEnum } from '@yaotai/common-utils';
import { TRANS_WEBP_STR } from '../components';

export const pdfTypeList = ['pdf'];
export const imageTypeList = ['jpg', 'jpeg', 'png', 'webp', 'jfif'];
export const videoTypeList = ['mp4', 'avi'];

export const allSupportedTypeList = [...pdfTypeList, ...imageTypeList, ...videoTypeList];
export const allPreviewSupportedTypeList = [...imageTypeList, ...videoTypeList];

export type ColorType = 'yellow' | 'blue' | 'green' | 'grey' | 'red';

export type TimezoneValue = {
  offset: string;
  zoneId?: string;
};

export type CompressUrl = {
  astc_url: string;
  dpi: number[] | null;
  origin_url: string;
};

export const INIT_COMPRESS_URL: CompressUrl = {
  dpi: [],
  astc_url: '',
  origin_url: '',
};

export enum ModelModeEnum {
  Add = 'add',
  Edit = 'edit',
}

export const ALL_IDENTIFY = 'ALL';

export const FROM_LOGIN_PAGE_QUERY = 'login';

export const CHROME_DOWNLOAD_LINK = 'https://static.fuxi.netease.com/yaotai/conference/static/ChromeSetup.exe';

export const NEED_AUTO_REGISTER = 'NEED_AUTO_REGISTER';

export const DEFAULT_FAVICON = 'data:;base64,=';

export enum LoginCBOption {
  Register = 'register',
  Subscribe = 'subscribe',
}

export const START_DAY_TIME = '00:00:00';
export const END_DAY_TIME = '23:59:59';

export const YAOTAI_ICO_PNG = `https://static.fuxi.netease.com/yaotai/portal/index/lqlsfnl6_336105.png?${TRANS_WEBP_STR}`;

export const YAOTAI_LOGO = `https://static.fuxi.netease.com/yaotai/portal/20220609/l470lyei_logo-white.png?${TRANS_WEBP_STR}`;
export const YAOTAI_LOGO_EN = `https://static.fuxi.netease.com/yaotai/portal/20220609/l470luj1_logo-white-en.png?${TRANS_WEBP_STR}`;
export const YAOTAI_LOGO_BLACK = `https://static.fuxi.netease.com/yaotai/portal/yaotai_resource/l46t3uzq_logo-black.png?${TRANS_WEBP_STR}`;
export const YAOTAI_LOGO_BLACK_EN = `https://static.fuxi.netease.com/yaotai/portal/20220609/l46t3owl_logo-black-en.png?${TRANS_WEBP_STR}`;

export const YAOTAI_DEFAULT_AVATAR = `https://static.fuxi.netease.com/yaotai/portal/20221115/lahsypp8_843227.png?${TRANS_WEBP_STR}`;
export const DEFAULT_GRAY_AVATAR = `https://static.fuxi.netease.com/yaotai/portal/20220629/l4z1qkz1_avatar-default-grey.png?${TRANS_WEBP_STR}`;

export const CORPORATE_SPACE_DEFAULT_LOGO = `https://static.fuxi.netease.com/yaotai/portal/index/lpi913j2_563358.png?${TRANS_WEBP_STR}`;

export const DEFAULT_BG = `https://static.fuxi.netease.com/yaotai/portal/index/lpj5a8m3_737562.png?${TRANS_WEBP_STR}`;
// 8-16 个字符，前后不能有空格，区分大小写
export const REGEX_A = /^\S.{6,14}\S$/;

// 字母、数字、空格及英文字符-=+_.,
export const REGEX_B = /^[a-zA-Z0-9-=+_.\s]+$/;

// 包含字母、数字及特殊字符两种及以上组合
export const REGEX_C = /^(?=.*[a-zA-Z0-9].*)(?=.*[a-zA-Z-=+_.\s].*)(?=.*[0-9-=+_.\s].*).*$/;

// 网易邮箱
export const REGEX_NETEASE_EMAIL = /^[a-zA-Z0-9_.-]+@((163|126|vip\.163|vip\.126|188)\.com|yeah\.net)$/;

// 网易 URL
export const REGEX_NETEASE_URL = /https?:\/\/[a-zA-Z0-9_.-]+((163|126|vip\.163|vip\.126|188)\.com|yeah\.net)/;

// 部署在 QA 集群的网易 URL
export const REGEX_QA_NETEASE_URL = /https?:\/\/[a-zA-Z0-9_.-]+apps-qa.danlu.netease.com/;

// corp 邮箱
export const REGEX_CROP_EMAIL = /^[a-zA-Z0-9_.-]+@(corp|mesg\.corp)\.netease\.com$/;

export const LOGIN_PAGE_URL = `${window.origin}/${SubPackageSlugEnum.Center}/login`; // 登录页的 URL

export const YAOTAI_RESPONSE_CONFIG = {
  xs: 575,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
  xxl: 1600,
  xxxl: 1920,
  // 同步之前的配置用法
  small: 0,
  middle: 800,
  large: 1320,
  customProductPage: 1435,
};

export const fileSizeToM = (file: File, round: boolean = true) => {
  return round ? Math.round((file?.size / 1024 / 1024) * 100) / 100 : file?.size / 1024 / 1024;
};

export const DEFAULT_MAIN_LOGO = `https://static.fuxi.netease.com/yaotai/portal/yaotai_resource/l46t3uzq_logo-black.png?${TRANS_WEBP_STR}`;

export const ANTD_THEME = {
  token: {
    colorPrimary: '#7566f5',
    colorPrimaryHover: '#7566f5',
    colorLinkHover: '#7566f5',
    colorLink: '#7566f5',
  },
};

export const EEVEE_ICON_YAOTAI_CDN_URL = `https://static.fuxi.netease.com/eevee-icon/resource/yaotai/KkPMS3UWmO1GepV.json`;

export enum CloudLoginTypeEnum {
  Account = 'account',
  Ticket = 'ticket',
  Tourist = 'tourist',
}

// 图片压缩方式
export enum ImgAstcType {
  AstcToOrigin = 1, // 对原图做astc压缩
  AstcToCompress = 2, // 对压缩后的图做astc压缩
}

export const UN_AUTHENTICATE_CODE_LIST = [401];

export const DEFAULT_ICO = 'https://static.fuxi.netease.com/yaotai/portal/index/lgloxkok_630324.ico';

export const NO_BANNER_ROUTE_PREFIX_LIST = ['/user/change-phone', '/record'];

export const DEFAULT_IMG = `https://static.fuxi.netease.com/yaotai/official/base_resource/default_cover.png?${TRANS_WEBP_STR}`;

export const GOOGLE_LOGIN_ICON = `https://static.fuxi.netease.com/yaotai/portal/index/llajlmk0_458543.png?${TRANS_WEBP_STR}`;
export const OTHER_LOGIN_ICON = `https://static.fuxi.netease.com/yaotai/portal/index/llaku7cj_538355.png?${TRANS_WEBP_STR}`;
export const NETEASE_LOGIN_ICON = `https://static.fuxi.netease.com/yaotai/portal/index/llakuxk3_572323.png?${TRANS_WEBP_STR}`;
export const WECHAT_LOGIN_ICON = `https://static.fuxi.netease.com/yaotai/portal/index/llakvayk_589692.png?${TRANS_WEBP_STR}`;

export const URS_SCRIPT_URL = `https://webzj.netstatic.net/webzj_cdn101/message4.js`;

export const LOGIN_WHITE_LIST = [
  '163.com',
  '126.com',
  'yeah.net',
  '188.com',
  '027youtu.com',
  'youdao.com',
  'netease.com',
  'lofter.com',
  'dahanghai.com',
  'easebar.com',
  'liveall.cn',
  '32jiefang.com',
];
